<template>
  <div id="home">
    <div class="row pt-5">
      <div class="col-12 col-lg-4">
        <a href="/page/ine/vip" title="VIP režim 6 - 12 mesiacov">
          <star/>
          <div class="text-center pt-5">
            <h3>VIP režim 6 - 12 mesiacov</h3>
          </div>
        </a>
      </div>
      <div class="col-12 col-lg-4">
        <a href="/page/ine/jasle" title="Jasle 1 - 2,5 roka">
          <star/>
          <div class="text-center pt-5">
            <h3>Jasle 1 - 2,5 roka</h3>
          </div>
        </a>
      </div>
      <div class="col-12 col-lg-4">
        <a href="/page/ine/skolka" title="2,5 - 6 rokov">
          <star/>
          <div class="text-center pt-5">
            <h3>2,5 - 6 rokov</h3>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Star from '@/components/star.vue';

export default {
  name: 'Home',
  components: { Star },
  computed: {
    textBtn() {
      return '>>> Tlačivo stiahnite tu <<<';
    },
  },
};
</script>
